import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// VERVANG DIT MET JE EIGEN FIREBASE CONFIG
// Ga naar https://console.firebase.google.com → Project Settings → Je apps
const firebaseConfig = {
    apiKey: "AIzaSyCt8mO11SQFmohDE02k2NiBi9UNtxYBNPk",
    authDomain: "kamp-systeem.firebaseapp.com",
    projectId: "kamp-systeem",
    storageBucket: "kamp-systeem.firebasestorage.app",
    messagingSenderId: "661332441899",
    appId: "1:661332441899:web:c6ef079f5e5fbe90caa36e"
};


const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
